import EventService from "../services/EventService";

export default {
  namespaced: true,

  state: {
    events: []
  },
  mutations: {

    saveEvents (state, value) {
      state.events = value
    }

  },
  actions: {

    async fetchEventsByParticipant ({ rootState, commit }) {
      const username = rootState.authParticipant.participant;
      const host = rootState.authParticipant.participantHost;
      const token = rootState.authParticipant.participantToken;


      try {
        const res = await EventService.fetchEventsByParticipant(
          { username, host },
          token
        );
        if (res) {
          commit("saveEvents", res.data.data);
        }
        return res;
      } catch (err) {
        throw new Error(err);
      }
    }
  }
};